export default __webpack_public_path__ + "static/media/usecase-medical.90124303.jpg";